export const PROMOTION_BANNER_SET_TYPE = {
	SKU: 'SKU',
	CATEGORY: 'CATEGORY',
};
